import React from "react";

const DeleteIcon: React.FC = () => (
  <svg width="15" height="15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#a)" fill="#000">
      <path d="M14.074 0 .05 14.025l.876.877L14.951.877 14.074 0Z" />
      <path d="m.938 0 14.025 14.025-.877.877L.061.877.938 0Z" />
    </g>
  </svg>
);
export default DeleteIcon;
